import { Pipe, PipeTransform }  from "@angular/core";

@Pipe({
    name: 'customWeight'
})
export class CustomWeight implements PipeTransform {

    transform(value: any, unit: string): string {
        const units = {
            'kg': 'Kilogram',
            't': 'Tonne',
            'lbs': 'LBS'
        };

        const formattedValue = value.toLocaleString('de-DE', {
            minimumFractionDigits: unit === 't' ? 3 : 2,
            thousandsSeparator: ','
        });

        // const formatter = new Intl.NumberFormat('de-DE', {
        //     minimumFractionDigits: unit === '' ? 3 : 2,
        //     thousandsSeparator: ','
        // });

        // const formattedValue = formatter.format(formattedValue);

        // console.warn(formattedValue);
        return `${formattedValue}`;
    }

}